import React, { useContext, useEffect, useState } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";
const Table21 = ({ setSharayeteNamosaedeMohiteKar, sharayeteNamosaedeMohiteKar, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const [data, setData] = useState([])
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.sharayeteNamosaedeMohiteKar;

    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 12, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 20, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 28, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },
      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setSharayeteNamosaedeMohiteKar(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "sharayeteNamosaedeMohiteKar": selectedItem }))
    }
  }, [reload])


  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          دود و بخار و محیط
          آلوده
        </Column>
        <Column paddingY={30}>
          گرد و غبار و سر صدا
        </Column>
        <Column paddingY={30}>
          رطوبت، گرما، سرما،
          آفتاب و نور
        </Column>
        <Column paddingY={30}>
          بوی نامطبوع، و
          کارهای شیمیایی
        </Column>
        <Column paddingY={30}>
          لرزش، ارتعاش و اشعه
        </Column>
      </Row>
      {/* <Row type={3}>
        <Column>3ساعت</Column>
        <Column>4ساعت</Column>
        <Column>2ساعت</Column>
        <Column>- </Column>
        <Column>- </Column>
      </Row> */}
      <Row type={2}>
        <Column isActive={sharayeteNamosaedeMohiteKar == 12}>12</Column>
        <Column isActive={sharayeteNamosaedeMohiteKar == 20}>20</Column>
        <Column isActive={sharayeteNamosaedeMohiteKar == 28}>28</Column>
        <Column isActive={sharayeteNamosaedeMohiteKar == 36}>36</Column>
        <Column isActive={sharayeteNamosaedeMohiteKar == 40}>40</Column>
      </Row>
      <Row type={5}>
        <Column> امتیاز شغل:</Column>
        <Column isActive={true} size={2}>
          {sharayeteNamosaedeMohiteKar}
        </Column>
      </Row>
    </div>
  );
};

export default Table21;
